/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * Platform API
 * The Platform API
 * OpenAPI spec version: 2.0
 */

export type UtxExchangeSubAccountGetSecuritiesTransferIntent = typeof UtxExchangeSubAccountGetSecuritiesTransferIntent[keyof typeof UtxExchangeSubAccountGetSecuritiesTransferIntent];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UtxExchangeSubAccountGetSecuritiesTransferIntent = {
  ACCOUNT_ADMIN_FEE: 'ACCOUNT_ADMIN_FEE',
  ACCOUNT_SETUP_FEE: 'ACCOUNT_SETUP_FEE',
  INTRA_ACCOUNT_INJECTION_FEE: 'INTRA_ACCOUNT_INJECTION_FEE',
  ADJUSTMENT: 'ADJUSTMENT',
  ASSET_INJECTION: 'ASSET_INJECTION',
  ASSET_WITHDRAWAL: 'ASSET_WITHDRAWAL',
  BILL_PAYMENT: 'BILL_PAYMENT',
  BOND_OPEN_ACCOUNT: 'BOND_OPEN_ACCOUNT',
  BOND_REDEMPTION: 'BOND_REDEMPTION',
  BOND_SUBSCRIPTION: 'BOND_SUBSCRIPTION',
  CARD_PAYMENT: 'CARD_PAYMENT',
  CHANGE_BENEFICIARIES: 'CHANGE_BENEFICIARIES',
  CHARGE: 'CHARGE',
  CLIENT_INVOICE: 'CLIENT_INVOICE',
  COMMISSION: 'COMMISSION',
  COMMODITIES: 'COMMODITIES',
  EARN_FEE: 'EARN_FEE',
  EARN_REDEMPTION: 'EARN_REDEMPTION',
  EARN_REDEMPTION_FEE: 'EARN_REDEMPTION_FEE',
  EARN_SUBSCRIPTION: 'EARN_SUBSCRIPTION',
  EXCHANGE_SUB_ACCOUNT_APPLICATION: 'EXCHANGE_SUB_ACCOUNT_APPLICATION',
  EXCHANGE_SUB_ACCOUNT_MONTHLY_FEE: 'EXCHANGE_SUB_ACCOUNT_MONTHLY_FEE',
  EXCHANGE_SUB_ACCOUNT_TRANSFER: 'EXCHANGE_SUB_ACCOUNT_TRANSFER',
  FEE: 'FEE',
  FOREX: 'FOREX',
  FUND_OPEN_ACCOUNT: 'FUND_OPEN_ACCOUNT',
  FUND_BOND_OPEN_BROKER_ACCOUNT: 'FUND_BOND_OPEN_BROKER_ACCOUNT',
  FUND_REDEMPTION: 'FUND_REDEMPTION',
  WMC_FUND_REDEMPTION: 'WMC_FUND_REDEMPTION',
  FUND_SUBSCRIPTION: 'FUND_SUBSCRIPTION',
  WMC_FUND_SUBSCRIPTION: 'WMC_FUND_SUBSCRIPTION',
  INSURANCE_ENQUIRY: 'INSURANCE_ENQUIRY',
  INSURANCE: 'INSURANCE',
  OTHER: 'OTHER',
  PURCHASE_ORDER: 'PURCHASE_ORDER',
  SECURITIES_APPLICATION: 'SECURITIES_APPLICATION',
  SECURITIES_TRANSFER: 'SECURITIES_TRANSFER',
  SELECTED_GLOBAL_MARKET_DATA_SERVICES: 'SELECTED_GLOBAL_MARKET_DATA_SERVICES',
  SETTLEMENT: 'SETTLEMENT',
  TRANSFER: 'TRANSFER',
  FUND_DISTRIBUTION: 'FUND_DISTRIBUTION',
  REMITTANCE: 'REMITTANCE',
  NFT_CUSTODY_SERVICE_FEE: 'NFT_CUSTODY_SERVICE_FEE',
  FUND_TRANSFER: 'FUND_TRANSFER',
  BOND_TRANSFER: 'BOND_TRANSFER',
  TRANSFER_SELF: 'TRANSFER_SELF',
  CARD_APPLICATION_FEE: 'CARD_APPLICATION_FEE',
  STATIC_VIRTUAL_ACCOUNT_OPENING: 'STATIC_VIRTUAL_ACCOUNT_OPENING',
  ACCOUNT_INJECTION_FEE: 'ACCOUNT_INJECTION_FEE',
  CARD_ACCOUNT_MANAGEMENT: 'CARD_ACCOUNT_MANAGEMENT',
  UNIP_SALES: 'UNIP_SALES',
  ACCOUNT_APPLICATION_FEE: 'ACCOUNT_APPLICATION_FEE',
  ACCOUNT_MONTHLY_FEE: 'ACCOUNT_MONTHLY_FEE',
  AUDIT_CONFIRMATION_FEE: 'AUDIT_CONFIRMATION_FEE',
  STORAGE_FEE: 'STORAGE_FEE',
  SCHEDULER: 'SCHEDULER',
  PROFIT_SHARING: 'PROFIT_SHARING',
} as const;
